// <!-- Start Analytics Wrapper-->
/*
WHAT: Generic analytics wrapper to use on all websites
-category = REQUIRED
-action = REQUIED
-properties = OPTIONAL (object of key/value pairs)
-element = OPTIONAL (the html element refence (not a string, the object reference))
-ecommerce = OPTIONAL (GA Enhanced Ecommerce https://developers.google.com/tag-manager/enhanced-ecommerce)

HOW TO INSTALL:
-minify (eg https://closure-compiler.appspot.com/home) =~ 500/800 bytes compressed/uncompressed
-inline inside source code (don't use exteranal JS file for such small code)
-at bottom of page BEFORE ANY OTHER JAVASCRIPT (to ensure each JS can use it)

HOW TO USE (FROM ANY JS CODE) EXAMPLES:
track('Page','Viewed',{page: {template: 'default'...}})
track('Dealer Locator','Loaded')
track('Filter', 'Opened', {filter: { id: 'main-filter' }}, el)
track('Filter', 'Item Clicked', {filter: { type: 'color', items: { black: 'on', red: 'off' } }}, el)
var ecommerce = {
detail: {
 products: [
   {
     name: "Triblend Android T-Shirt",
     id: "12345",
     price: "15.25",
     brand: "Google",
     category: "Apparel",
     variant: "Gray",
   },
     ],
 },
 };
 var props = { page: { type: "product" } }
 var el; // pointer to the element within the DOM

 track("Product", "Detail Page Viewed", props, el,ecommerce);
 */
 ;(function (t, r, a, c, k) {
  var valid_string = function (v) {
   return v && typeof v === "string" && v !== ""
  }
  var valid_obj = function (v) {
   return v && typeof v === "object" && Object.keys(v).length
  }
  var error = function (msg, v) {
   console.error("type=", typeof v, "  value=", v)
   throw new Error("TRACK v3.2: " + msg + ", see debug value above")
  }
  var is_defined = function (v) {
   return typeof v !== "undefined"
  }
  var log = function () {
   var color = "background-color: black; color: white; padding: 2px"
   var args = Array.prototype.slice.call(arguments)
   args.unshift("%cTRACK v3.2:", color)
   console.log.apply(console, args)
  }
  t.track = function (category, action, props, element, ecom) {
   if (!valid_string(category)) error("invalid [category]", category)
   if (!valid_string(action)) error("invalid [action]", action)
   if (is_defined(props) && !valid_obj(props)) error("invalid [props]", props)
   if (is_defined(ecom) && !valid_obj(ecom)) error("invalid [ecom]", ecom)
  
   // Mandatory fields
   // Prefixing with "track_" so in GTM we have a universal trigger
   var event = {
     event: "track_" + category + "_" + action,
     category: category,
     action: action,
   }
   // Optional objects
   if (props) event.properties = props
   if (element) event.component_element = element
   // ECOMMERCE:
   // Normalizing the payload, ie grabbing what's inside "ecommerce" if it's nested
   // GA needs the payload to be nested under the ecommerce key
   // hence when reading from the dataLayer we need to wrap it again
   // NOTE: the above/below might seem overkill but it's really important to nomalize
   // payload to avoid issues with GTM
   if (ecom) {
    if ("ecommerce" in ecom) {
      ecom = ecom.ecommerce
    }
    event.ecommerce = ecom
   } 
   // Initializing DL if GTM hasn't loaded yet and pushing data
   t[r] = t[r] || []
   // Clearing ecommerce object to be safe
   t[r].push({ ecommerce: null })
   t[r].push(event)
   log(
     "category=",
     category,
     " action=",
     action,
     " props=",
     props,
     " element=",
     element,
     " ecom=",
     ecom
   )
  }
})(window, "dataLayer")
